<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import { customerService } from "../../../services/contactservice/customer.service";
import { propertyService } from "../../../services/propertyservice/property.service";
import { propertyattachmentService } from "../../../services/propertyservice/propertyattachment.service";
import { servicehelpers } from "../../../services/servicehelpers";
import i18n from "../../../i18n";
import Loading from "@/components/c-loading";

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Area,
    Dropzone,
    Select
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      currency: "",
      selectCustomer: null,
      propertyData: null,
      customerData: {},
      projectData: {},
      floorData: {},
      statusData: {},
      typeData: {},
      groupData: {},
      currencyData: {},
      breadCrumb: {},
      attachement: {},
      dataCode: '',
      dataType: 0,
      dataCustomer: 0,
      dataDescription: '',
      dataNetSize: 0,
      dataGrossSize: 0,
      dataFloor: 0,
      dataProject: 0,
      dataGroup: 0,
      dataStatus: 0,
      dataCurrency: 0,
      dataPrice: 0,
      dataPhoto: [],
      dataLivingRoomNo: 0,
      dataBedRoomNo: 0,
      dataKitchenNo: 0,
      dataBathRoomNo: 0,
      dataBalconyNo: 0,
      dataDoc: [],
    };
      
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingTypeData();
    this.loadingStatusData();
    this.loadingProjectData();
    this.loadingFloorData();
    this.loadingCurrencyData();
    this.loadingGroupData();
    this.loadingCustomerData();

    this.dataType = 1;
    this.dataStatus = 1;
    this.dataCurrency = 1;

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          // console.log(response);

          if(response.data == null) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add"
            });
          }

          this.breadCrumb = {
            text: response.data.code,
            active: true,
          };

          this.fetchingStats = true;
          this.propertyData = response;

          this.dataCustomer = this.propertyData.data.customer_id;

          this.dataCode = this.propertyData.data.code;
          this.dataType = this.propertyData.data.property_type_id;
          this.dataDescription = this.propertyData.data.description;

          this.dataNetSize = this.formatCurrency(this.propertyData.data.net_size);
          this.dataGrossSize = this.formatCurrency(this.propertyData.data.cross_size);
          this.dataFloor = this.propertyData.data.project_floor_id;
          this.dataProject = this.propertyData.data.project_id;
          this.dataGroup = this.propertyData.data.property_group_id;
          this.dataStatus = this.propertyData.data.property_status_id;
          this.dataCurrency = this.propertyData.data.currency_id;
          this.dataPrice = this.propertyData.data.price;

          this.dataLivingRoomNo = this.propertyData.data.living_room_no;
          this.dataBedRoomNo = this.propertyData.data.bed_room_no;
          this.dataKitchenNo = this.propertyData.data.kitchen_no;
          this.dataBathRoomNo = this.propertyData.data.bathroom_no;
          this.dataBalconyNo = this.propertyData.data.balcony_no;
          
          this.propertyData.data.collections.map(item => {
            if('property_attachments' in item) {
              // this.dataPhoto = item.property_attachments;
              this.dataDoc = item.property_attachments.filter(attachment => attachment.path != null);
            } 
          });
        

          this.loadingFloorData();
          this.loadingCustomerById(this.propertyData.data.customer_id);
          this.loadingPropertyAttachmentByPropertyId(this.propertyData.data.id);
        });
    },

    loadingCustomerData: function() {
      customerService.getList()
        .then(response => {
          
          this.customerData = response;
        });
    },

    loadingCustomerById: function(id) {
      customerService.getOne(id)
        .then(response => {
          // console.log(JSON.stringify(response.data));
          this.selectCustomer = response.data;
        });
    },

    loadingPropertyById: function(propertyId) {

      let param = propertyId == 0 ? '?page=0' : `?page=0&clause={"clause":[{"conjuction":"and","properties.id":{"value":${propertyId}}}]}`;

      propertyService.getList(param)
        .then(response => {
          this.propertyData = response;
        });
    },

    loadingPropertyAttachmentByPropertyId: function(propertyId) {

      let param = propertyId == 0 ? '?page=0' : `?page=0&clause={"clause":[{"conjuction":"and","property_attachments.property_id":{"value":${propertyId}}}]}`;

      propertyattachmentService.getList(param)
        .then(response => {
          this.attachement = response;
        });
    },

    loadingCurrencyData: function() {
      servicehelpers.getCurrencyData().then(response => {
        this.currencyData = response;
      });
    },

    loadingTypeData: function() {
      servicehelpers.getPropertyTypeData().then(response => {
        this.typeData = response;
      });
    },

    loadingStatusData: function() {
      servicehelpers.getPropertyStatusData().then(response => {
        this.statusData = response;
      });
    },

    loadingProjectData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projectData = response;
      });
    },

    loadingFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        // this.floorData = response;
        let arr = [];
        response.data.map((item) => {
          // item.number = item.number * 2
          item["text"] = item.number < 9 ? `0${item.number}` : `${item.number}`;
          arr.push(item);

        });

        this.floorData = {data: arr};
      });
    },

    loadingGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },

    handleSelectProject: function(id) {
      this.loadingFloorData(id);
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
          });

        }
      });

      
    },
    submitSave: function() {
      this.tryingToSubmit = true;

      let obj = {
        parent_id: 0,
        code: this.dataCode,
        property_type_id: this.dataType,
        description: this.dataDescription,
        net_size: this.dataNetSize,
        cross_size: this.dataGrossSize,
        project_floor_id: this.dataFloor,
        project_id: this.dataProject,
        property_group_id: this.dataGroup,
        property_status_id: this.dataStatus,
        currency_id: this.dataCurrency,
        price: this.dataPrice,
        // property_attachments: this.dataPhoto,
        living_room_no: this.dataLivingRoomNo,
        bed_room_no: this.dataBedRoomNo,
        kitchen_no: this.dataKitchenNo,
        bathroom_no: this.dataBathRoomNo,
        balcony_no: this.dataBalconyNo
        
      };

      console.log(JSON.stringify(obj));

      if(this.isAdd) {
        propertyService.insert(obj)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "property-list"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(customer));
        propertyService.update(this.$route.params.id, obj)
         .then(response => {

          console.log(JSON.stringify(response));

          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });

          }
        });

      }
    },

    clearForm: function() {
      this.dataCode = '';
      this.dataType = 0;
      this.dataCustomer = 0;
      this.dataDescription = '';
      this.dataNetSize = 0;
      this.dataGrossSize = 0;
      this.dataFloor = 0;
      this.dataProject = 0;
      this.dataGroup = 0;
      this.dataStatus = 0;
      this.dataCurrency = 0;
      this.dataPrice = 0;
      this.dataPhoto = [];

      this.dataLivingRoomNo = 0;
      this.dataBedRoomNo = 0;
      this.dataKitchenNo = 0;
      this.dataBathRoomNo = 0;
      this.dataBalconyNo = 0;

      this.dataDoc = [];
    },

    currencyChanged: function(event) {

      const cur = this.currencyData.data.find(obj => {
        return obj.id === event
      });

      this.currency = cur == null ? "" : cur.name_en;
    
    }, 

    uploadDocSuccess(file, response) {
        console.log(file);

        if(response.data != null) {
          this.dataDoc.push({
            path: response.data
          });
        }
    },

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

    getCrossSize() {
      return this.formatCurrency(this.dataGrossSize); 
    },

    getNetSize() {
      return this.formatCurrency(this.dataNetSize);
    }
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, {
        text: $t('property.new'),
        active: true
      }]" :title="this.isAdd ? $t('property.new') : $t('property.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, this.breadCrumb]" :title="this.isAdd ? $t('property.new') : $t('property.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <div v-show="fetchingStats" class="row">
      <b-form class="row">
        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    v-model="dataCode"
                    :label="'customer.code'" 
                    :require="true"
                  /> 
                </div>
                <div class="col-md-6">
                  <Select 
                    :text="'name'"
                    :id="'project_id'"
                    v-model="dataProject"
                    :list="this.projectData"
                    :label="'property.project'"
                    :require="true"
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Select 
                    :id="'project_floor_id'"
                    v-model="dataFloor"
                    :text="'text'"
                    :prefix="$t('general.floor-no') + ' '"
                    :list="this.floorData"
                    :label="'property.floor'"
                    :require="true"
                  /> 
                </div>
                <div class="col-md-6">
                  <Select 
                    :text="'name'"
                    :id="'property_group_id'"
                    v-model="dataGroup"
                    :list="this.groupData"
                    :label="'property.group'"
                    :require="true"
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Select 
                    :text="'name'"
                    :id="'property_type_id'"
                    v-model="dataType"
                    :disabled="true"
                    :list="this.typeData"
                    :label="'property.type'"
                  /> 
                </div>
                <div class="col-md-6">
                  <Select 
                    :text="'name'"
                    :id="'property_status_id'"
                    v-model="dataStatus"
                    :list="this.statusData"
                    :label="'property.status'"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'price'"
                    v-model="dataPrice"
                    :last="currency"
                    :label="'property.price'" 
                    :require="true"
                  />
                </div>
                <div class="col-md-6">
                  <Select 
                :text="'name'"
                    @change="currencyChanged" 
                    :id="'currency_id'"
                    v-model="dataCurrency"
                    :list="this.currencyData"
                    :label="'property.currency'"
                    :disabled="true"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'cross_size'"
                    :last="'general.square'"
                    v-model="dataGrossSize"
                    :label="'property.gross-size'" 
                  />
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :last="'general.square'"
                    :id="'net_size'"
                    v-model="dataNetSize"
                    :label="'property.net-size'" 
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'bed_room_no'"
                    v-model="dataBedRoomNo"
                    :label="'property.bed-room-no'" 
                  />
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'living_room_no'"
                    v-model="dataLivingRoomNo"
                    :label="'property.living-room-no'" 
                  />
                </div>

                 <div class="col-md-2">
                  <Input 
                    :type="'number'"
                    :id="'kitchen_no'"
                    v-model="dataKitchenNo"
                    :label="'property.kitchen-no'" 
                  />
                </div>
                <div class="col-md-2">
                  <Input 
                    :type="'number'"
                    :id="'bathroom_no'"
                    v-model="dataBathRoomNo"
                    :label="'property.bathroom-no'" 
                  />
                </div>
                <div class="col-md-2">
                  <Input 
                    :type="'number'"
                    :id="'balcony_no'"
                    v-model="dataBalconyNo"
                    :label="'property.balcony-no'" 
                  />
                </div>

              </div>

              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="7"
                    :id="'description'"
                    v-model="dataDescription"
                    :label="'property.description'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">

                  <b-form inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </b-form>
     
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          
          <div v-if="this.selectCustomer" class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="card-title mb-4">{{$t('customer.text')}}</h4>
                    </div>
                    <!-- <div class="col-md-4">
                      <Button v-bind:icon="'bx bx-plus-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'success'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.new')"  />
                    </div> -->
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4 mb-3">{{this.$t('customer.name')}}</div>
                    <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.name}}</b></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 mb-3">{{this.$t('customer.name-en')}}</div>
                    <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.name_en}}</b></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 mb-3">{{this.$t('customer.id-type')}}</div>
                    <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.idType}}</b></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 mb-3">{{this.$t('customer.number')}}</div>
                    <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.id_no}}</b></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 mb-3">{{this.selectCustomer && this.selectCustomer.phone_no_2 ? this.$t('customer.phone-no-1') : this.$t('customer.phone-no')}}</div>
                    <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.phone_no_1}}</b></div>
                  </div>
                  <div class="row" v-show="this.selectCustomer != null && this.selectCustomer.phone_no_2">
                    <div class="col-md-4 mb-3">{{this.$t('customer.phone-no-2')}}</div>
                    <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.phone_no_2}}</b></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 mb-3">{{this.$t('customer.email')}}</div>
                    <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.email}}</b></div>
                  </div>
                  <div v-show="this.selectCustomer && (this.selectCustomer.partner_name && this.selectCustomer.partner_have_to)">
                    <div class="card-title mb-3"></div>
                    <h4 class="card-title mb-3">{{$t('customer.partner-info')}}</h4>
                    <div class="row">
                      <div class="col-md-4 mb-3">{{this.$t('customer.name')}}</div>
                      <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.partner_name}}</b></div>
                    </div>
                    <div class="row">
                      <div class="col-md-4 mb-3">{{this.$t('customer.partner-type')}}</div>
                      <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.partner_have_to}}</b></div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="mt-3">
                <!-- <label for="formFileDoc" class="form-label">{{$t('property.doc')}}</label>
                <input class="form-control" type="file" id="formFileDoc" /> -->
                <Dropzone 
                    :id="'doc'"
                    :maxFiles="5"
                    :preview="dataDoc[0] && dataDoc[0].path"
                    :label="'customer.doc'" 
                    @uploadSuccess="uploadDocSuccess" />
              </div>
            </div>
          </div>

        </div>
      </b-form>
    </div>    
  </Layout>
</template>